import React from 'react';
import P from 'prop-types';
import './styles.css';

export const LabelPreco = ({ price = '', oldPrice = '', className = '', is_principal_multpreco = false }) => {
  const priceFormatted = price.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });

  const odlPriceFormatted = oldPrice.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });

  return (
    <div className={className}>
      {is_principal_multpreco && 'A partir de '}
      {priceFormatted}
      {oldPrice && <span className="oldPrice">{odlPriceFormatted}</span>}
    </div>
  );
};

LabelPreco.propTypes = {
  price: P.number.isRequired,
  oldPrice: P.string,
  className: P.string,
  is_principal_multpreco: P.bool,
};
